// src/pages/DebtStudio/lib/buildPrincipalPeriods.js

import dayjs from "lib/dayjs";

export function principalFreqToStepMonths(principalFrequency) {
  const freq = String(principalFrequency || "annual").toLowerCase();

  const map = {
    monthly: 1,
    bimonthly: 2,
    quarterly: 3,
    every_four_months: 4,
    triannual: 4,
    semiannual: 6,
    annual: 12,
  };

  return map[freq] ?? 12;
}

export function buildPrincipalPeriods({
  startDate,
  periodEndAnchor,
  lastCashflowDate,
  principalFrequency = "annual",
}) {
  if (!startDate || !periodEndAnchor || !lastCashflowDate) return [];

  const start = dayjs(startDate);
  const lastPayment = dayjs(lastCashflowDate);
  const anchor = dayjs(periodEndAnchor);

  if (!start.isValid() || !lastPayment.isValid() || !anchor.isValid()) return [];

  const stepMonths = principalFreqToStepMonths(principalFrequency);

  let firstEnd = anchor.clone();

  while (!firstEnd.isAfter(start, "day")) {
    firstEnd = firstEnd.add(stepMonths, "month");
  }

  // The first principal payment date defines the recurring period-end grid,
  // but it is not necessarily the first period end after the dated date.
  // Walk backward on that grid so a delayed first principal payment does not
  // collapse multiple presentation periods into one oversized initial period.
  while (firstEnd.subtract(stepMonths, "month").isAfter(start, "day")) {
    firstEnd = firstEnd.subtract(stepMonths, "month");
  }

  const periods = [];
  let pStart = start.clone();
  let pEnd = firstEnd.clone();

  while (pEnd.isBefore(lastPayment, "day")) {
    periods.push({
      start: pStart.clone(),
      end: pEnd.clone(),
    });

    pStart = pEnd.clone();
    pEnd = pEnd.add(stepMonths, "month");
  }

  periods.push({
    start: pStart.clone(),
    end: pEnd.clone(),
  });

  return periods;
}

export function buildAnnualPeriods(startDate, periodEndAnchor, lastCashflowDate) {
  return buildPrincipalPeriods({
    startDate,
    periodEndAnchor,
    lastCashflowDate,
    principalFrequency: "annual",
  });
}
